import { InjectableClass } from '@fino/lib-injection';

export class UserSummaryServiceProvider extends InjectableClass {
  constructor(validationRulesProvider) {
    'ngInject';
    super({ validationRulesProvider });

    this.activate();
  }

  get branchIdPattern() {
    return /\b^\d{5}$\b/g;
  }

  $get() {
    return {};
  }

  activate() {
    this.validationRulesProvider.addRule(
      'branchId',
      (value) => this.branchIdPattern.test(value)
    );
  }
}
